import React, { Component, createElement } from 'react';
import classNames from 'classnames';
import Icon from '../../common/components/Icon';
import Spinner from '../../common/components/Spinner';

const Button = ({
	variant,
	color,
	size,
	block,
	fillWidth,
	fillHeight,
	iconName,
	rounded,
	iconPadding,
	raised,
	loading,
	submit,
	disabled,
	onClick,
	children
}) => {
	const classes = classNames(
		'button',
		`button--${variant}`,
		`button--${variant}-${color}`,
		{
			'button--block': block,
			'button--fill-width': fillWidth,
			'button--fill-height': fillHeight,
			'button--rounded': rounded,
			'button--icon-padding': iconPadding,
			'button--raised': raised,
			'button--small': size === 'small'
		}
	);

	const type = submit ? 'submit' : 'button';

	const isClickable = !loading && onClick;

	const iconClasses = classNames('button__icon', {
		'button__icon--margin': children
	});

	const icon =
		iconName &&
		<div className={iconClasses}>
			<Icon icon={iconName} />
		</div>;

	const spinner =
		loading &&
		<div className="button__spinner">
			<Spinner />
		</div>;

	return (
		<button
			className={classes}
			type={type}
			disabled={disabled}
			onClick={isClickable && onClick}
		>
			<span className="button__wrapper">
				{spinner}
				{icon}
				{children}
			</span>
		</button>
	);
};

const PrimaryButton = props =>
	<Button variant="default" color="primary" {...props} />;

const SecondaryButton = props =>
	<Button variant="default" color="secondary" {...props} />;

const InvertedPrimaryButton = props =>
	<Button variant="inverted" color="primary" {...props} />;

const InvertedSecondaryButton = props =>
	<Button variant="inverted" color="secondary" {...props} />;

const FlatPrimaryButton = props =>
	<Button variant="flat" color="primary" {...props} />;

const FlatSecondaryButton = props =>
	<Button variant="flat" color="secondary" {...props} />;

const FloatingButton = props =>
	<Button variant="floating" color="primary" {...props} />;

const FloatingAccentButton = props =>
	<Button variant="floating" color="accent" {...props} />;

/*
class Button extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isFocus: false,
			isActive: false,
		}

		this.renderFocusEffect = this.renderFocusEffect.bind(this)
		this.handleFocus = this.handleFocus.bind(this)
		this.handleBlur = this.handleBlur.bind(this)

		this.handleMouseDown = this.handleMouseDown.bind(this)
		this.handleMouseUp = this.handleMouseUp.bind(this)
	}

	render() {
		const { children, onClick } = this.props
		const { isFocus, isActive } = this.state
		//const { color  }

		const hasFocus = isFocus && !isActive

		const buttonClass = classNames(
			'button', {
				//'button--primary': isFocus
			}
		)


		return (
			<button
				className={buttonClass}
				onFocus={this.handleFocus}
				onBlur={this.handleBlur}
				onMouseDown={this.handleMouseDown}
				onMouseUp={this.handleMouseUp}
				onClick={onClick}
				ref={button => this.button = button}>
				<div>
					{children}
					{hasFocus && this.renderFocusEffect()}
				</div>
			</button>
		)
	}

	renderFocusEffect() {

		if(!this.button) { // This is bad.
			return null
		}

		const radius = this.button.offsetWidth * 0.7
		const top = (this.button.offsetHeight / 2) - (radius / 2)
		const left = (this.button.offsetWidth / 2) - (radius / 2)

		const style = {
			position: 'absolute',
			top: `${top}px`,
			left: `${left}px`,
			width: `${radius}px`,
			height: `${radius}px`,
			background: 'rgba(255, 255, 255, 0.2)',
			borderRadius: '50%',
		}

		const className = 'button--test'

		const div = createElement('div', {
			style,
			className,
		})

		return div

	}

	handleFocus() {
		this.setState({ isFocus: true })
	}

	handleBlur() {
		this.setState({ isFocus: false })
	}

	handleMouseDown() {
		this.setState({ isActive: true })
	}

	handleMouseUp() {
		this.setState({ isActive: false })
	}
}
*/
export {
	PrimaryButton,
	SecondaryButton,
	FlatPrimaryButton,
	FlatSecondaryButton,
	InvertedPrimaryButton,
	InvertedSecondaryButton,
	FloatingButton,
	FloatingAccentButton
};



// WEBPACK FOOTER //
// ./src/js/Ui/Button/Button.jsx